module.exports = __webpack_public_path__ + "media/images/sample_routing-fca616bf7b14a672ffcfb4efde460c48.jpg";